export const LIFE_MILESTONE_3_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Checklist items",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_description: "",
    meta_priority: 1,
    meta_status: 1,
  },

  METADATA_FIELDS: [
    {
      fieldName: "meta_description",
      label: "Checklist item (with check icon)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Faculty Interaction",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "meta_priority",
      label: "Order",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "1",
      required: false,
      defaultValue: 1,
    },
    {
      fieldName: "meta_status",
      label: "Active",
      value: 1,
      valueType: "number",
      filedType: "TOGGLE",
      placeholder: "",
      required: false,
      defaultValue: 1,
    },
  ],

  LIFE_MILESTONE_3_FIELDS_CONFIG: [
    {
      fieldName: "block_main_title",
      label: "Main title (52px)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Learn Anywhere, Anytime",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "block_subtitle",
      label: "Second title (32px)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "with our Mobile App",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "block_body",
      label: "Body (18px)",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Supporting copy",
      required: false,
      defaultValue: "",
      rows: 4,
    },
    {
      fieldName: "block_cta_label",
      label: "Button label (16px)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Start Learning Now",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "block_cta_url",
      label: "Button URL",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://… — used when Is CTA is off",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "is_cta",
      label: "Is CTA",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "On = open lead capture popup instead of button URL",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "background_color",
      label: "Section background",
      value: "#291973",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#291973",
      required: false,
      defaultValue: "#291973",
    },
    {
      fieldName: "hero_image",
      label: "Desktop image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload desktop image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "hero_image_mobile",
      label: "Mobile image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload mobile image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "hero_image_alt",
      label: "Image alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],
};
